import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class GalleryNoResult extends React.Component {
    static propTypes = {
        page: PropTypes.number,
        query: PropTypes.string,
        customText: PropTypes.string
    };
    static defaultProps = {
        page: 1,
        query: '',
        customText: ''
    }

    constructor(props) {
        super(props);
    }

    render() {
        const { page, customText, query} = this.props;

        if (page === 1) {
            return (
                <div className="component-gallery-no-result">
                    {customText ? (
                        <h1 className="no-results-headline">
                            {customText}
                        </h1>
                    ) : (
                        <h1 className="no-results-headline">
                            Oops. We couldn’t find any results{query ? ` for "${query}"` : ''}.
                        </h1>
                    )}

                    {query && (<p className="no-results-subheadline">Check the spelling or try to modify your search.</p>)}
                    <img className="no-results-icon" src={require('./images/no-results-icon.png')} />
                </div>
            );
        } else {
            return (
                <div className="component-gallery-no-result">
                    <h1 className="no-results-headline">
                        Oops. We couldn’t find more results{query ? ` for "${query}"` : ''}.
                    </h1>
                    {query && (<p className="no-results-subheadline">Check the spelling or try to modify your search.</p>)}
                    <img className="no-results-icon" src={require('./images/no-results-icon.png')} />)}
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryNoResult/index.js